import { Button, Modal, message } from "antd";
import "./modal-share.scss";
import logoFB from "@/public/icon/icon-logo-facebook.svg";
import linkicon from "@/public/icon/icon-link.svg";
import Image from "next/image";
import { useState } from "react";

const ModalShare = ({ openModal, setOpenModal }) => {
  const handleOk = () => {
    setOpenModal(false);
  };

  const handleCancel = () => {
    setOpenModal(false);
  };

  const shareOnFacebook = () => {
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      window.location.href
    )}`;
    const windowFeatures =
      "width=500,height=100,resizable,scrollbars,left=700px,top=150px,menubar=no,toolbar=no,status=no,noopener,noreferrer";
    window.open(shareUrl, "_blank", windowFeatures);
  };

  const copyLink = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        message.success("Link đã được sao chép!");
      })
      .catch(() => {
        message.error("Không thể sao chép link!");
      });
  };

  return (
    <>
      <Modal
        className="modal-share-social"
        title="Chia sẻ"
        width={300}
        open={openModal}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        closable={false}
        centered
      >
        <div className="share-button">
          <Button className="facebook-button" onClick={shareOnFacebook}>
            <Image src={logoFB} width={16} height={16} alt="image" />
            <span>Chia sẻ lên Facebook</span>
          </Button>
        </div>
        <div className="share-button">
          <Button className="link-button" onClick={copyLink}>
            <Image src={linkicon} width={16} height={16} alt="image" />
            <span>Copy link chia sẻ</span>
          </Button>
        </div>
      </Modal>
    </>
  );
};
export default ModalShare;
